import { type FC, type PropsWithChildren } from 'react'

import { TakeoverContentWrapperBase } from '@/components-page/advertisement/TakeoverContentWrapperBase'
import { HOMEPAGE_GPT_ID } from '@/components-page/homepage/advertisement/homepageAdSlots'
import { useTakeoverDetection } from '@/hooks/useTakeoverDetection'

export const TakeoverContentWrapper: FC<PropsWithChildren> = ({ children }) => {
  const hasTakeover = useTakeoverDetection(HOMEPAGE_GPT_ID.TAKEOVER)

  return (
    <TakeoverContentWrapperBase hasTakeover={hasTakeover}>{children}</TakeoverContentWrapperBase>
  )
}
